export default "__VITE_ASSET__e01e44fc__"